import apiClient from './apiClient';
import { cleanParams } from '@/utils/buildQuery';

const base = '/admin/mains';

export const mainsService = {
  list: (params) => apiClient.get(base, { params: cleanParams(params) }),
  get: (id) => apiClient.get(`${base}/${id}`),
  reevaluate: (id) => apiClient.post(`${base}/${id}/reevaluate`),
  update: (id, payload) => apiClient.patch(`${base}/${id}`, payload),
  remove: (id) => apiClient.delete(`${base}/${id}`),
  stats: () => apiClient.get(`${base}/stats`),
};

export default mainsService;
